import {ConfigureModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const analysisTabs = defineTabDef({
  items: {
    tabName: 'items',
    tabTitle: 'Items',
    requiredAnyPermission: [ConfigureModulePermissionCodes.view_items],
  },
  locations: {
    tabName: 'locations',
    tabTitle: 'Areas/Stores',
    requiredAnyPermission: [ConfigureModulePermissionCodes.view_areas_stores],
  },
  map: {
    tabName: 'map',
    tabTitle: 'Map',
    requiredAnyPermission: [ConfigureModulePermissionCodes.view_map],
  },
} as const);
